// admin-categories.component.ts
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Category } from '../models/category-model';
import { CategoryService } from '../services/category.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-admin-categories',
  templateUrl: './admin-categories.component.html'
})
export class AdminCategoriesComponent implements OnInit {
  categories: Category[] = [];
  rootCategoryForm: FormGroup;
  constructor(private fb: FormBuilder, private categoryService: CategoryService) {
    this.rootCategoryForm = this.fb.group({
      name: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.loadCategoriesTree();
  }

  loadCategoriesTree() {
    this.categoryService.getTree().subscribe(data => {
      this.categories = data;
    });
  }

  addRootCategory() {
    if (this.rootCategoryForm.valid) {
      this.categoryService.createCategory({
        name: this.rootCategoryForm.value.name,
        parentId: null
      }).subscribe(() => {
        this.rootCategoryForm.reset();
        this.loadCategoriesTree();
      });
    }
  }
}
